export default __webpack_public_path__ + "static/media/headerBg.c2bca3f5.png";